import React from 'react';

const Vision = () => {
    return (
        <section className="flex flex-col items-center justify-center  w-screen h-64 md:h-72 my-10 md:my-0">
            <h1 className="text-jemak-500 font-jemak text-2xl md:text-4xl">Our Vision</h1>
            <p className="font-jemak text-center w-80 md:w-[928px] text-sm md:text-xl mt-4">
                We are the company of choice recognized by our employees for core values and opportunities for personal and professional growth.
                We are a preeminent independent supplier of choice recognized by our customers as the best in total satisfaction and value.
            </p>
        </section>
  );
};

export default Vision;
